import { useRef } from 'react'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { usePageShowReload } from '../../../../hooks'
import {
  useAsyncTable,
  useTableRefresh,
  useTableReloadAfterMassAction,
} from '../../../Table'

export function useCategoryTablePage({
  asyncTableOptions,
  entity,
  sub = null,
  onApplyTableConfig,
}) {
  const pageScrollWrapperRef = useRef(null)

  const asyncTable = useAsyncTable({
    ...asyncTableOptions,
    containerRef: pageScrollWrapperRef,
    entity,
    sub,
  })

  const { columns, filterValues, handleReload, isRefetching, view } = asyncTable

  const {
    handleChangeShouldReloadFilters,
    handleReloadTableAfterMassAction,
    shouldReloadFilters,
  } = useTableReloadAfterMassAction({
    filterValues,
    sub,
    onReload: handleReload,
  })

  const { refreshButtonProps } = useTableRefresh({
    isRefetching,
    onReload: handleReload,
  })

  usePageShowReload(handleReload)

  async function handleApply(obj = EMPTY_OBJECT) {
    if (onApplyTableConfig) {
      return onApplyTableConfig({
        ...obj,
        columns,
        view,
      })
    }
  }

  return {
    ...asyncTable,
    handleApply,
    handleChangeShouldReloadFilters,
    handleReloadTableAfterMassAction,
    pageScrollWrapperRef,
    refreshButtonProps,
    shouldReloadFilters,
  }
}
